import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Logo from '../assets/albert_logo_white.svg'
import LoginIcon from '../assets/login_face_black.svg'
import ArrowDown from '../assets/arrow-down-black.svg'
import ArrowDownWhite from '../assets/arrow_down.svg'
import LoginUserIcon from '../assets/login.svg'
import {menuItems, metaTags} from '../utils/content'
import DropDown from './DropDown'
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux'
import { logEvent, pushToDataLayer } from './Analytics'
import Seo from './Seo';

class Header extends React.Component{
    constructor(porps){
        super(porps)
    }

    closeHeader = () => {
        const {dispatchHeaderMenu} = this.props;
        dispatchHeaderMenu(false);
        document.getElementsByTagName('body')[0].className = '';
    }

    render(){
        const {logoColor, dropDownColor, dispatchHeaderMenu, headerMobileActive, title} = this.props;
        const { favicon } = this.props.query;

        return(
            <Fragment>
                <Helmet
                    title={title}
                    meta={metaTags}
                    link={[
                        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon.publicURL}` },
                    ]}
                />
                <Seo />
                <div className={`${this.props.classStatic} header-sec`} onMouseLeave={() => this.closeHeader()}>
		            <div className="custom-container">
                        <div className="row logo-sec">
                            <div className="col-lg-6 col-sm-6 col-md-6 col-xs-6">
                                <div className="logo-img">	
                                    <Link to="/">
                                        <Logo style={{fill: logoColor}} />
                                    </Link>
                                </div>
                            </div>	
                            <div className="col-lg-6 col-sm-6 col-md-6 col-xs-6">
                                <ul>
                                    <li>
                                        <DropDown 
                                            leftIcon={dropDownColor === 'white' ? <LoginUserIcon /> : <LoginIcon />}
                                            rightIcon={dropDownColor === 'white' ? <ArrowDownWhite /> : <ArrowDown/>}
                                            text="Logga in"
                                            textColor={dropDownColor === 'white' ? '#fff' : "#2c2c3d"}
                                            menuItems={menuItems}
                                            onMouseEneter={ dispatchHeaderMenu }
                                            readHeader={headerMobileActive}
                                        />
                                    </li>
                                    <li><a href="/register" className="btn-bran" onClick={e => {
                                        logEvent(
                                            `Header Bjud ditt barn på läxhjälp button`,
                                            `Header Bjud ditt barn på läxhjälp button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Header Bjud Ditt Barn På Läxhjälp Button',
                                            'Header Bjud Ditt Barn På Läxhjälp Button Was Clicked'
                                        )
                                        }}>Bjud ditt barn på läxhjälp</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const reduxRegisterState = (state) => {
    return {
        headerMobileActive: state.headerMobileActive,
    }
}
  
const reduxRegisterStateDispatch = dispatch => {
    return { 
        dispatchHeaderMenu: (plan) => dispatch({ type: `HEADER_MOBILE_MENU`, value: plan }),
    }
}

const Head =  connect(reduxRegisterState, reduxRegisterStateDispatch)(Header);
export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    favicon: file(relativePath: {regex: "/faviicon/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <Head query={data} {...props}/>
        )}
    />
)
